
import { metaData } from '~/configuration/metaData';
import { CMSService } from '~/services/storyBlok/cmsService';
import ReviewsGrid from '~/components/storyblok/ReviewsGrid/ReviewsGrid.vue';
import ProductAboveTheFold from '~/components/v2/pdps/ProductAboveTheFold.vue';
import FaqSection from '~/components/shop/FaqSection.vue';
import { FCButton } from '@fc/angie-ui';
import storeMutations from '~/store/constants/storeMutations';

export default {
  name: 'fightcamp',
  head: {
    ...metaData.fightcamp,
  },
  components: {
    ProductAboveTheFold,
    ReviewsGrid,
    FaqSection,
    FCButton,
  },
  data() {
    return {
      reviews: [],
      faqs: [],
      pdpUpsells: [],
    };
  },
  mounted() {
    this.$store.commit(storeMutations.SET_MODAL_SUPPRESSION, true);

    if (window.affirm && window.affirm.ui) {
      window.affirm.ui.ready(() => {
        window.affirm.ui.refresh();
      });
    }
  },
  destroyed() {
    this.$store.commit(storeMutations.SET_MODAL_SUPPRESSION, false);
  },
  methods: {
    scrollToTop() {
      if (process.client) {
        window.scrollTo({
          top: 0,
          behavior: 'smooth',
        });
      }
    },
  },
  async asyncData({
    $storyapi, error, $eCommService,
  }) {
    try {
      const storyBlok = new CMSService({ cmsService: $storyapi });
      const reviews = await storyBlok.getAll('user-reviews');

      const faqs = await storyBlok.get('global/globalpackagefaqs');
      const faqList = faqs?.data?.story?.content?.global?.[0]?.container || [];

      const upsellsResult = await $eCommService.getCollection({ id: process.env.NUXT_ENV_SHOPIFY_PDP_UPSELL_COLLECTION });
      const pdpUpsells = upsellsResult?.map(p => ({
        ...p,
        value: p.variants[0].id,
        cta: 'Add to Cart',
        isDisabled: false,
      })) ?? [];

      return {
        reviews, faqs: faqList, pdpUpsells,
      };
    } catch (e) {
      error({ message: e.message });
      return {};
    }
  },
};
